import AuthService from "../services/AuthService";
import OrganizationService from "../services/OrganizationService";
import UserService from "../services/UserService";
import i18n from "../i18n/config";
import { setProfileDetails, setProfileStateList } from "../store/SessionSlice";
import { setSessionIsActive } from "../store/CommonSlice";
import { isSet } from "./commonUtils";
import { OK } from "./constant";

/**
 * Response from POST patient-form-login (or patient-form-login-md) step 2 after OTP —
 * payload built in SnapPatientFormController (HS256 patient session JWT).
 */
export function extractPatientSessionAuthPayload(apiResponse) {
  if (!apiResponse || apiResponse.status === "ERROR") return null;
  const d = apiResponse.data;
  if (!d) return null;
  if (typeof d === "object" && d.access_token) return d;
  if (d.original?.data?.access_token) return d.original.data;
  return null;
}

/**
 * Stores JWT + minimal profile so axios uses the same token storage keys as staff Passport sessions.
 */
export async function applyPatientSessionAuthFromApiResponse(apiResponse, dispatch) {
  if (apiResponse?.code !== OK) return false;
  const authPayload = extractPatientSessionAuthPayload(apiResponse);
  if (!authPayload?.access_token) return false;

  AuthService.storeToken(authPayload.access_token);
  AuthService.storeRefreshToken(authPayload.refresh_token);
  const profileData = authPayload.userProfile;
  if (profileData) {
    UserService.storeProfile(profileData);
    if (isSet(profileData.organization_id, null) !== null) {
      OrganizationService.storeOrgId(profileData.organization_id);
      OrganizationService.storeTimeZone(profileData.organization_id);
    }
    i18n.changeLanguage(profileData.preferred_language);
    AuthService.storePrefLanguage(profileData.preferred_language);
    AuthService.store2FAverifed(profileData.two_factor_verified);
    AuthService.storeProfileId(profileData.id);
    dispatch(setProfileDetails({ key: profileData.id, value: profileData }));
    dispatch(setSessionIsActive(true));
    try {
      const stateListResponse = await UserService.getUserStateList();
      const states = [{ label: "-Select State-", value: "" }];
      stateListResponse?.forEach((val) => states.push({ label: val.code, value: val.code }));
      dispatch(setProfileStateList(states));
    } catch {
      /* ignore */
    }
  }
  return true;
}
